import PropTypes from "prop-types";
import { memo } from "react";

import { useCurrentFormatCurrency } from "@hooks/usePrices";
import useResponsiveWithHydrationFix from "@hooks/useResponsiveWithHydrationFix";
import { cn } from "@helpers/general";
import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import { ComponentType } from "@constants/ComponentType";
import GiftIcon from "@svgs/gift-new.svg";

function GiftWithPurchasePrice({ componentType, price }) {
  const formatWithCurrency = useCurrentFormatCurrency();

  const size = useResponsiveWithHydrationFix(14, 15);

  return (
    <div className="flex flex-col items-start gap-[3px]">
      <p
        className={cn("strikethrough text-dark-grey", {
          "typo-body font-bold":
            componentType === ComponentType.CP ||
            componentType === ComponentType.CP_ADS ||
            componentType === ComponentType.PRODUCT_CAROUSEL ||
            componentType === ComponentType.SEARCH,
          "typo-h2 desktop:typo-h3":
            componentType === ComponentType.PDP || componentType === ComponentType.PDP_ADS,
        })}
      >
        {formatWithCurrency(parseFloat(price))}
      </p>
      <GiftIcon fill="#FFFFFF" stroke="#2D2927" width={size} height={size} />
    </div>
  );
}

GiftWithPurchasePrice.propTypes = {
  price: PropTypes.number,
  componentType: PropTypes.string,
};

export default withALErrorBoundary({
  name: "GiftWithPurchasePrice",
  priority: "P1",
})(memo(GiftWithPurchasePrice));
